import React, { Component } from "react";
import { connect } from "react-redux";

import { withRouter } from "react-router";
import ProductHeader from "../ProductDetails/ProductHeader";

import Section from "./components/Section";
import PromotionItem from "./PromotionItem";
import { ReactComponent as Discount } from "./assets/discount.svg";
import { ReactComponent as Gift } from "./assets/gift.svg";
import { ReactComponent as Star } from "./assets/star.svg";

import HorizontalList from "./HorizontalList";
import Banner from "./components/Banner";
import Glass from "./components/Glass";
import IconList from "./components/IconList";
import Elevation from "./components/Elevation";
import WavingHand from "./components/Wave";
import Drawer from "./components/Drawer";
import { Apply_Promo, setProduct } from "../../store/actions";
import QRCode from "qrcode.react";
class LoyaltyHomePage extends Component {
  state = {
    loading: false,

    drawerOpen: false,
    drawerContent: {
      imageUrl:
        "https://images.zyda.co/cdn-cgi/image/width=828,f=auto,metadata=none/photos/menu_items/photo_urls/8e4eb0c5-0913-476c-9062-8504f16a9467/original/%D8%A8%D8%A7%D9%8A%D8%AA%D8%B3_%D8%A7%D9%84%D8%A8%D8%B7%D8%B1%D9%8A%D9%82.jpeg?1695306590",
      title: "Hi",
      content: "Descrdiption",
      actionText: "",
      callback: () => alert("hi"),
    },
  };

  toggleDrawer = (open) => {
    this.setState({ drawerOpen: open });
  };
  setDrawerContent = (content) => {
    this.setState({ drawerContent: { ...content } });
  };

  componentDidMount = async () => {
    try {
      this.setState({ loading: true });
      // const res = await instance.get("get_wallet_history/");
    } catch (err) {}
    this.setState({ loading: false });
  };
  SendToAddProducts(products) {
    this.props.setProduct();
    const returnURL = this.props.returnURL;
    this.props.history.replace(
      `/product/${products[0].category}/${
        products[0].parent ? products[0].parent + "/" : ""
      }${products[0].slug}`,
      { pending_items: products.slice(1), returnURL: returnURL }
    );
  }
  render() {
    const {
      auth,
      language,
      settings,
      store,
      promotions,
      appliedPromotion,
      freeProducts,
    } = this.props;
    const { history, loading, drawerOpen } = this.state;

    let loyaltyPromotions = promotions.filter((p) => p.loyalty_points_cost > 0);
    let externalFreeItems = freeProducts
      .filter((p) => p.is_external_loyalty_reward && p.quantity >= 1)
      .map((promoItem) => {
        return {
          ...promoItem,
          originalProduct: promotions.find((p) => p.id === promoItem.promo)
            ?.discounts?.[0]?.products[0],
        };
      });
    const mockItemList = [
      {
        title: (language === "arabic" && "احصل على نقاط") || "Get Points",
        icon: (
          <Star
            style={{
              maxWidth: 36,
              maxHeight: 36,
              width: "80%",
              height: "80%",
              margin: 5,
            }}
          />
        ),
        paragraph:
          (language === "arabic" && "احصل على نقاط عند اتمام عملية شراء") ||
          "Get rewarded points with your orders.",
      },
      // {
      //   title: "Claim free items",
      //   icon: (
      //     <Gift
      //       style={{
      //         maxWidth: 36,
      //         maxHeight: 36,
      //         width: "80%",
      //         height: "80%",
      //         margin: 5,
      //       }}
      //     />
      //   ),
      //   paragraph: "Use your points to claim free items.",
      // },
      {
        title: (language === "arabic" && "عروض خاصة") || "Special promotions",
        icon: (
          <Discount
            style={{
              maxWidth: 36,
              maxHeight: 36,
              width: "80%",
              height: "80%",
              margin: 5,
            }}
          />
        ),
        paragraph:
          (language === "arabic" && "إستخدم نقاطك للحصول على عروض خاصة") ||
          "Use your points with special promotions.",
      },
    ];
    const mockProducts = [
      {
        name: "A this is a super long text that will most likely span multiple lines and so on and so forth but hopefully it cuts",
        price: "price",
        imageUrl:
          "https://images.zyda.co/cdn-cgi/image/width=828,f=auto,metadata=none/photos/menu_items/photo_urls/8e4eb0c5-0913-476c-9062-8504f16a9467/original/%D8%A8%D8%A7%D9%8A%D8%AA%D8%B3_%D8%A7%D9%84%D8%A8%D8%B7%D8%B1%D9%8A%D9%82.jpeg?1695306590",
      },
      {
        name: "B",
        price: "price",
        imageUrl:
          "https://images.zyda.co/cdn-cgi/image/width=828,f=auto,metadata=none/photos/menu_items/photo_urls/dd2ca338-8034-44c7-8508-d7b3066a54c0/original/%D8%A8%D9%88%D9%83%D8%B3_%D9%86%D8%AA%D9%81%D9%87_%D8%B3%D9%8A%D8%B1%D9%8A%D9%84%D8%A7%D9%83.jpg?1700397209",
      },
      { name: "C", price: "price" },
      { name: "D", price: "price" },
      { name: "E", price: "price" },
      { name: "Item", price: "price" },
      { name: "Item", price: "price" },
    ];
    // if (
    //   !auth.user ||
    //   !settings.enable_wallet ||
    //   !settings.enable_wallet_staff
    // ) {
    //   this.props.history.replace("/profile");
    // }
    return (
      <div className="text-center" style={{ minHeight: "100vh" }}>
        <ProductHeader onBack={() => this.props.history.replace("/")} />

        <div
          style={{
            position: "relative",
            textAlign: "center",
            background: `url('${
              store.cover_medium || store.cover
            }') no-repeat center center`,
            backgroundSize: "cover",
            minHeight: 250,
            minWidth: 300,
            marginTop: 50,
            textAlign: language == "arabic" ? "right" : "left",
          }}
        >
          <div style={{ padding: 16, position: "relative", zIndex: 10 }}>
            <div style={{ color: "#fdfdfd", fontSize: 18, fontWeight: "bold" }}>
              {(language === "arabic" && "مرحبا") || "Hello"} <WavingHand />
            </div>
          </div>
          <div
            style={{
              position: "absolute",
              margin: 10,
              bottom: 0,
              zIndex: 10,
              left: language == "arabic" ? "auto" : 0,
              right: language == "arabic" ? 0 : "auto",
              display: "flex",
              justifyContent: "space-between",
              gap: 10,
            }}
          >
            {auth.user && (
              <Glass
                additionalStyles={{ width: "120px" }}
                content={
                  <>
                    <div style={{ fontSize: 12 }}>
                      {(language === "arabic" && "رصيد النقاط") ||
                        "Points Earned"}{" "}
                    </div>
                    <div
                      style={{
                        fontSize: 32,
                        borderRadius: "8px",
                        margin: "auto",
                        lineHeight: "60px",
                      }}
                    >
                      {auth?.user.points}
                      <Star
                        style={{
                          width: 32,
                          height: 32,
                          position: "relative",
                          top: "-5px",
                        }}
                      />{" "}
                    </div>

                    {/* <div style={{ fontSize: 12, color: "#e6e6e6" }}>
                      How points work
                    </div> */}
                  </>
                }
              />
            )}
          </div>

          <div
            style={{
              position: "absolute",
              zIndex: 5,
              top: 0,
              left: 0,
              opacity: 0.5,
              background:
                "linear-gradient(180deg, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0.5))",
              minHeight: 250,
              minWidth: 300,
              width: "100%",
            }}
          ></div>
        </div>
        {
          // Lets make an instructional section
        }
        {auth?.user?.username && (
          <Section
            title={"Your QR"}
            surface={false}
            content={
              <>
                <Elevation
                  content={
                    <QRCode
                      value={
                        settings.enable_aseer_time
                          ? auth?.user?.username.replace("+965", "")
                          : "CustomerQR:" + auth?.user?.uuid
                      }
                      size={150}
                      className="mt-2"
                      id={"QR"}
                      onClick={() => {
                        this.setDrawerContent({
                          content: (
                            <div style={{ textAlign: "center" }}>
                              <QRCode
                                value={
                                  settings.enable_aseer_time
                                    ? auth?.user?.username.replace("+965", "")
                                    : "CustomerQR:" + auth?.user?.uuid
                                }
                                size={300}
                                className="mt-2"
                                id={"QR2"}
                              />
                            </div>
                          ),
                          title: "Your QR",
                          actionButtonDisabled: false,
                          imageUrl: null,
                          actionText: "Close",
                        });
                        this.toggleDrawer(true);
                        return;
                      }}
                    />
                  }
                />{" "}
              </>
            }
          />
        )}
        <Section
          title={(language === "arabic" && "احصل علي نقاط") || "Earn Points"}
          language={language}
          surface={false}
          content={
            <>
              <Elevation
                content={<IconList items={mockItemList} language={language} />}
                callback={
                  !auth.user
                    ? () => this.props.history.replace("/profile")
                    : undefined
                }
              />
            </>
          }
        />
        {auth.user && (
          <>
            {externalFreeItems?.length > 0 && (
              <Section
                title={
                  (language === "arabic" && "🎁 منتجات مجانية") ||
                  "Free for you 🎁  "
                }
                language={language}
                content={
                  <HorizontalList
                    language={language}
                    content={
                      <>
                        {externalFreeItems.map((promo) => {
                          return (
                            <PromotionItem
                              showTag
                              tagText={
                                (language === "arabic" && "مجاني") || "FREE"
                              }
                              orientation="vertical"
                              title={
                                (language === "arabic" &&
                                  promo.originalProduct.ar_name) ||
                                promo.originalProduct.name
                              }
                              langauge={language}
                              imageUrl={
                                promo.originalProduct.photo_medium ||
                                promo.originalProduct.photo
                              }
                              callback={() =>
                                this.SendToAddProducts([promo.originalProduct])
                              }
                            />
                          );
                        })}
                      </>
                    }
                    is_scrollAble={true}
                    callback={() => alert("hi")}
                  />
                }
                callback={() => this.props.history.push(`/rewards`)}
                surface={true}
              />
            )}
            {loyaltyPromotions?.length > 0 && (
              <Section
                title={(language === "arabic" && "العروض") || "Promotions"}
                language={language}
                content={
                  <HorizontalList
                    language={language}
                    content={
                      <>
                        {loyaltyPromotions.map((promo) => {
                          return (
                            <PromotionItem
                              showTag={true}
                              tagText={
                                (language == "arabic" &&
                                  `${promo.loyalty_points_cost} نقطة`) ||
                                `${promo.loyalty_points_cost} Point${
                                  promo.loyalty_points_cost > 1 ? "s" : ""
                                }`
                              }
                              orientation="horizontal"
                              title={
                                (language === "arabic" && promo.ar_name) ||
                                promo.name
                              }
                              langauge={language}
                              imageUrl={
                                promo.banner ||
                                store.cover_medium ||
                                store.cover
                              }
                              callback={() => {
                                this.setDrawerContent({
                                  imageUrl:
                                    promo.banner ||
                                    store.cover_medium ||
                                    store.cover,
                                  content:
                                    (language === "arabic" &&
                                      promo.ar_discount_description) ||
                                    promo.discount_description,
                                  title:
                                    (language === "arabic" && promo.ar_name) ||
                                    promo.name,
                                  actionButtonDisabled:
                                    promo.loyalty_points_cost >
                                    auth?.user?.points,

                                  actionText:
                                    promo.loyalty_points_cost >
                                    auth?.user?.points
                                      ? language === "arabic"
                                        ? "نقاط غير كافيه"
                                        : "Not enough points"
                                      : appliedPromotion?.id === promo.id
                                      ? language === "arabic"
                                        ? "تعطيل العرض"
                                        : "Unapply Promotion"
                                      : language === "arabic"
                                      ? "تفعيل العرض"
                                      : "Apply Promotion",

                                  callback: () => {
                                    this.toggleDrawer(false);
                                    this.props.Apply_Promo(
                                      appliedPromotion?.id !== promo.id && {
                                        ...promo,
                                        promo: { ...promo },
                                        isSmartPromo: true,
                                      }
                                    );
                                  },
                                });
                                this.toggleDrawer(true);
                              }}
                            />
                          );
                        })}
                      </>
                    }
                    is_scrollAble={true}
                    callback={() => alert("hi")}
                  />
                }
                callback={() => this.props.history.push(`/rewards`)}
                surface={true}
              />
            )}

            {/* <Section
              title={"New Items"}
              language={language}
              content={
                <HorizontalList
                  language={language}
                  content={
                    <>
                      {mockProducts.map((item) => {
                        return (
                          <PromotionItem
                            orientation="horizontal"
                            title={item.name}
                            langauge={language}
                            imageUrl={item.imageUrl}
                          />
                        );
                      })}
                    </>
                  }
                  is_scrollAble={true}
                  callback={() => alert("hi")}
                />
              }
              callback={() => this.props.history.push(`/rewards`)}
              surface={true}
            />
            <Section
              title={false}
              language={"english"}
              content={
                <Banner
                  title={"banner"}
                  language={"hi"}
                  height={200}
                  imageUrl={
                    "https://images.zyda.co/cdn-cgi/image/width=828,f=auto,metadata=none/photos/menu_items/photo_urls/8e4eb0c5-0913-476c-9062-8504f16a9467/original/%D8%A8%D8%A7%D9%8A%D8%AA%D8%B3_%D8%A7%D9%84%D8%A8%D8%B7%D8%B1%D9%8A%D9%82.jpeg?1695306590"
                  }
                  callback={() => alert("I am clicked")}
                />
              }
              callback={() => this.props.history.push(`/rewards`)}
              surface={false}
            /> */}
          </>
        )}
        <div style={{ minHeight: 100, display: "block" }}></div>

        <Drawer
          drawerContent={this.state.drawerContent}
          open={this.state.drawerOpen}
          close={() => this.toggleDrawer(false)}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    auth: state.auth,
    settings: state.store.store.settings,
    store: state.store.store,
    promotions: state.store.store.smart_promos,
    freeProducts: state.cart.discounts.products,
    appliedPromotion: state.cart.promos,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    Apply_Promo: (promo) => dispatch(Apply_Promo(promo)),
    setProduct: () => dispatch(setProduct()),
  };
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LoyaltyHomePage)
);
